import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { useQueryParams } from 'hooks/useQueryParams/useQueryParams';
import { Location } from 'features/locations/location.types';
import { GeoEventEditorLayout } from 'features/geoEvents/components/GeoEventEditorLayout';
import { useAuthState } from 'state/useAuthState';
import { LocationForm } from './LocationForm';

type LocationQueryParams = {
  parentGeoEventId?: string | null;
  parentGeoEventType?: 'wildfire' | 'flooding' | null;
};

export const CreateEditLocation = (
  props: RouteComponentProps<{ locationId?: string }>,
): JSX.Element => {
  const {
    match: {
      params: { locationId },
    },
  } = props;
  const { t } = useTranslation();
  const [{ parentGeoEventId, parentGeoEventType }] =
    useQueryParams<LocationQueryParams>();
  const {
    permissions: { canCreateLocation },
  } = useAuthState();

  return (
    <GeoEventEditorLayout
      id={locationId}
      hasAccess={canCreateLocation}
      createHelmetTitle={t('createEditLocation.title.add')}
      editHelmetTitle={t('createEditLocation.title.edit')}
      renderSuccess={(geoEvent) => (
        <LocationForm
          location={geoEvent as unknown as Location}
          parentGeoEventId={
            parentGeoEventId ? parseInt(parentGeoEventId, 10) : undefined
          }
          parentGeoEventType={parentGeoEventType ?? undefined}
        />
      )}
    />
  );
};
